
//=============================================================================
// Contents   : HRDB
//              人件費区分マスタ一覧画面
//              GetCostList
// Author     : RV小寺
// LastUpdate : 2023/3/28
// Since      : 2022/12/11
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React from "react";

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */
import { MasterTemp } from "01Pages/Template/MasterTemp";

/* ====== Style ====== */
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */


/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 人件費区分マスタ一覧 ========= */
export const GetCostList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== sessionStorageからの情報を定義 ====== */ 

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== 取得API項目の設定 ====== */
	const  getConfig = {
        key:['aplySrtDate'],
        payload:
            {
                name:'lboCstClasfMstInfo', 
                    list:[
                        {name:'aplySrtDate',             base64:false},
                        {name:'lboCstClasfList',          
                            list:[
                                {name:'dispOrd',         base64:false},
                                {name:'lboCstClasfCd',   base64:false},
                                {name:'lboCstClasfName', base64:true},
                            ],
                        },
                    ]
            }          
    };
    /* ======== テーブルの設定 ======== */
    /*------ ヘッダの設定 ------*/
    // id       : 項目名
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　true

    /* ====== テーブルヘッダーを定義 ====== */
    const headData = [
    	{ id: 'dispOrd', align: 'left', width: '80px',label1: '表示順'},//〇〇データ
    	{ id: 'lboCstClasfCd', align: 'left', width: '160px', label1:'人件費区分コード'},//〇〇データ
    	{ id: 'lboCstClasfName',align: 'left', width: '140px', label1: '人件費区分名'},//〇〇データ
    ];

    /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton

    /* ====== テーブルデータを定義 ====== */
    const bodyData = [
        { name: 'dispOrd', type: 'label',  align: 'left'},
        { name: 'lboCstClasfCd', type: 'label',  align: 'left'},
        { name: 'lboCstClasfName',type: 'label',  align: 'left'},
    ];

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */


    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
			<MasterTemp
				listType='noneEdit'//一覧タイプ(master:　編集ありの通常のマスタ、noneEdit:編集なし)
				pageTitle='人件費区分マスタ'//画面タイトル
				apiPath='/master/getlistlabourcosts'
				headData={headData}//テーブルヘッダ設定
				bodyData={bodyData}//テーブルボディ設定
				getConfig={getConfig}//テーブル取得設定
			/>
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 
